module.exports = __webpack_public_path__ + "static/media/RP-59.050f4dbd.pdf";